import React from 'react';
import styles from './ServiceCard.module.css';
// Ensure you have react-icons installed: npm install react-icons
// No need for iconMap anymore as we pass the component directly

function ServiceCard({ iconComponent: IconComponent, title, bulletPoints }) {
  return (
    <div className={styles.serviceCard}>
      <div className={styles.iconContainer}>
        {IconComponent && <IconComponent className={styles.cardIcon} />}
      </div>
      <h3>{title}</h3>
      {bulletPoints && (
        <ul>
          {bulletPoints.map((point, index) => (
            <li key={index}>{point}</li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default ServiceCard;